import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Table } from "reactstrap"

export default function index(props) {
  const {
    models,
    model,
    onDesignNDetailChange,
    pleats1,
    pleats1s,
    pleats2,
    pleats2s,
    fronts,
    front,
    sidePocket,
    sidePockets,
    pissPocket1,
    pissPocket1s,
    pissPocket2,
    pissPocket2s,
    flap,
    flaps,
    takeOutYourBelt,
    takeOutYourBelts,
    outerSideStitch,
    outerSideStitchs,
    beltLoop,
    beltLoops,
    adjuster,
    adjusters,
    beltWidth,
    beltWidths,
    hemSpecification,
    hemSpecifications,
    backOfTheKnee,
    backOfTheKnees,
    suspenderButton,
    suspenderButtons,
  } = props.config
  return (
    <>
      <p className="text-center">DESIGN/DETAIL</p>
      <Table bordered>
        <tbody>
          <tr>
            <th style={{ width: 145 }}>モデル</th>
            <td>
              <SelectBox
                options={models}
                value={model}
                onChange={val =>
                  onDesignNDetailChange({ key: "model", value: val })
                }
              />
            </td>
          </tr>

          <tr>
            <th>プリーツ</th>
            <td>
              <SelectBox
                options={pleats1s}
                value={pleats1}
                onChange={val =>
                  onDesignNDetailChange({ key: "pleats1", value: val })
                }
              />
            </td>
          </tr>
          <tr>
            <th>プリーツ</th>

            <td>
              <SelectBox
                options={pleats2s}
                value={pleats2}
                onChange={val =>
                  onDesignNDetailChange({ key: "pleats2", value: val })
                }
              />
            </td>
          </tr>
          <tr>
            <th>フロント</th>
            <td>
              <SelectBox
                options={fronts}
                value={front}
                onChange={val =>
                  onDesignNDetailChange({ key: "front", value: val })
                }
              />
            </td>
          </tr>
          <tr>
            <th>脇ポケット</th>
            <td>
              <SelectBox
                options={sidePockets}
                value={sidePocket}
                onChange={val =>
                  onDesignNDetailChange({
                    key: "sidePocket",
                    value: val,
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <th>ピスポケット</th>
            <td>
              <SelectBox
                options={pissPocket1s}
                value={pissPocket1}
                onChange={val =>
                  onDesignNDetailChange({
                    key: "pissPocket1",
                    value: val,
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <th>ピスポケット</th>
            <td>
              <SelectBox
                options={pissPocket2s}
                value={pissPocket2}
                onChange={val =>
                  onDesignNDetailChange({
                    key: "pissPocket2",
                    value: val,
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <th>フラップ</th>
            <td>
              <SelectBox
                options={flaps}
                value={flap}
                onChange={val =>
                  onDesignNDetailChange({ key: "flap", value: val })
                }
              />
            </td>
          </tr>
          <tr>
            <th>ベルト持出</th>
            <td>
              <SelectBox
                options={takeOutYourBelts}
                value={takeOutYourBelt}
                onChange={val =>
                  onDesignNDetailChange({
                    key: "takeOutYourBelt",
                    value: val,
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <th>外脇ステッチ</th>
            <td>
              <SelectBox
                options={outerSideStitchs}
                value={outerSideStitch}
                onChange={val =>
                  onDesignNDetailChange({
                    key: "outerSideStitch",
                    value: val,
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <th>ベルトループ</th>
            <td>
              <SelectBox
                options={beltLoops}
                value={beltLoop}
                onChange={val =>
                  onDesignNDetailChange({ key: "beltLoop", value: val })
                }
              />
            </td>
          </tr>
          <tr>
            <th>アジャスター</th>
            <td>
              <SelectBox
                options={adjusters}
                value={adjuster}
                onChange={val =>
                  onDesignNDetailChange({ key: "adjuster", value: val })
                }
              />
            </td>
          </tr>
          <tr>
            <th>ベルト巾</th>
            <td>
              <SelectBox
                options={beltWidths}
                value={beltWidth}
                onChange={val =>
                  onDesignNDetailChange({
                    key: "beltWidth",
                    value: val,
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <th>裾口仕様</th>
            <td>
              <SelectBox
                options={hemSpecifications}
                value={hemSpecification}
                onChange={val =>
                  onDesignNDetailChange({
                    key: "hemSpecification",
                    value: val,
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <th>ひざ裏</th>
            <td>
              <SelectBox
                options={backOfTheKnees}
                value={backOfTheKnee}
                onChange={val =>
                  onDesignNDetailChange({
                    key: "backOfTheKnee",
                    value: val,
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <th>サスペンダー釦</th>
            <td>
              <SelectBox
                options={suspenderButtons}
                value={suspenderButton}
                onChange={val =>
                  onDesignNDetailChange({
                    key: "suspenderButton",
                    value: val,
                  })
                }
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  )
}
